import React from 'react';

import { useFormContext } from 'react-hook-form';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './HowItWorksSection.module.scss';
import { FormFieldsGrid } from '../../../FormFieldsGrid/FormFieldsGrid';
import { ChallengeFormValues } from '../../../../../interfaces/ChallengeFormValues';
import {
  RichTextEditor,
  RichTextViewer,
} from '../../../../../../shared/features/rich-text';
import { Mode } from '../../../../../../general-types';
import { ModeAwareInput } from '../../../../../../shared/components/form-components';
import { validateRichTextWhitespace } from '../../../../../../shared/utils/reactHookFormUtils';

type HowItWorksSectionProps = {
  mode: Mode;
};

export const HowItWorksSection = ({ mode }: HowItWorksSectionProps) => {
  const { control } = useFormContext<ChallengeFormValues>();

  const generalInputProps = {
    size: 'small',
  } as const;

  return (
    <FormFieldsGrid mode={mode}>
      <TitleWithDescription
        title="How it Works?"
        titleFont="body-14-bold"
        description="In this section, you will let participants know everything about your contest. Keep it clear and concise. Do not write one long paragraph. Format it the way you would like it to look on your custom landing page."
        className={classes.span2Rows}
      />
      <div className={classes.span2}>
        <ModeAwareInput
          mode={mode}
          control={control}
          name="about.about"
          label="About"
          renderValue={(value: string | null | undefined) =>
            value ? <RichTextViewer content={value} /> : '—'
          }
          renderEdit={(props) => (
            <RichTextEditor
              {...generalInputProps}
              {...props}
              rules={{
                required: 'About is required',
                validate: { validateRichTextWhitespace },
              }}
            />
          )}
        />
      </div>
      <div className={classes.span2}>
        <ModeAwareInput
          mode={mode}
          control={control}
          name="about.additionalInfo"
          label="What you'll need/additional info"
          renderValue={(value: string | null | undefined) =>
            value ? <RichTextViewer content={value} /> : '—'
          }
          renderEdit={(props) => (
            <RichTextEditor
              {...generalInputProps}
              {...props}
              rules={{
                required: 'Additional info is required',
                validate: { validateRichTextWhitespace },
              }}
            />
          )}
        />
      </div>
    </FormFieldsGrid>
  );
};
